module.exports = __webpack_public_path__ + "img/app_shop.9d6d67f4.png";